export default {
  translation: {
    common: {
      save: 'บันทึก',
      cancel: 'ยกเลิก',
      delete: 'ลบ',
      edit: 'แก้ไข',
      add: 'เพิ่ม',
      search: 'ค้นหา',
      loading: 'กำลังโหลด...',
      success: 'สำเร็จ',
      error: 'ข้อผิดพลาด',
      confirm: 'ยืนยัน',
      yes: 'ใช่',
      no: 'ไม่',
      back: 'กลับ',
      next: 'ถัดไป',
      submit: 'ส่ง',
      close: 'ปิด',
      required: 'จำเป็น',
      optional: 'ไม่จำเป็น',
    },
    auth: {
      login: 'เข้าสู่ระบบ',
      logout: 'ออกจากระบบ',
      register: 'ลงทะเบียน',
      email: 'อีเมล',
      password: 'รหัสผ่าน',
      confirmPassword: 'ยืนยันรหัสผ่าน',
      forgotPassword: 'ลืมรหัสผ่าน?',
      resetPassword: 'รีเซ็ตรหัสผ่าน',
      loginSuccess: 'เข้าสู่ระบบสำเร็จ',
      logoutSuccess: 'ออกจากระบบสำเร็จ',
      invalidCredentials: 'อีเมลหรือรหัสผ่านไม่ถูกต้อง',
      emailSent: 'ส่งอีเมลรีเซ็ตรหัสผ่านแล้ว',
    },
    household: {
      title: 'ครัวเรือน',
      createHousehold: 'สร้างครัวเรือน',
      householdName: 'ชื่อครัวเรือน',
      householdAddress: 'ที่อยู่',
      members: 'สมาชิก',
      addMember: 'เพิ่มสมาชิก',
      removeMember: 'ลบสมาชิก',
      switchHousehold: 'เปลี่ยนครัวเรือน',
      currentHousehold: 'ครัวเรือนปัจจุบัน',
      noHousehold: 'ไม่มีครัวเรือน',
    },
    task: {
      title: 'งาน',
      createTask: 'สร้างงาน',
      taskTitle: 'ชื่อเรื่อง',
      description: 'คำอธิบาย',
      dueDate: 'วันครบกำหนด',
      priority: 'ความสำคัญ',
      status: 'สถานะ',
      category: 'หมวดหมู่',
      assignTo: 'มอบหมายให้',
      startTask: 'เริ่ม',
      finishTask: 'เสร็จสิ้น',
      completeTask: 'เสร็จสมบูรณ์',
      cancelTask: 'ยกเลิก',
      taskStarted: 'เริ่มงานแล้ว',
      taskFinished: 'งานเสร็จแล้ว',
      taskCompleted: 'งานเสร็จสมบูรณ์',
      taskCancelled: 'งานถูกยกเลิก',
      highPriority: 'สูง',
      mediumPriority: 'ปานกลาง',
      lowPriority: 'ต่ำ',
      pending: 'รอดำเนินการ',
      inProgress: 'กำลังดำเนินการ',
      completed: 'เสร็จสมบูรณ์',
      cancelled: 'ยกเลิกแล้ว',
    },
    expense: {
      title: 'ค่าใช้จ่าย',
      createExpense: 'เพิ่มค่าใช้จ่าย',
      amount: 'จำนวนเงิน',
      category: 'หมวดหมู่',
      date: 'วันที่',
      description: 'คำอธิบาย',
      receipt: 'ใบเสร็จ',
      verify: 'ตรวจสอบ',
      verified: 'ตรวจสอบแล้ว',
      pending: 'รอดำเนินการ',
      rejected: 'ปฏิเสธ',
    },
    quotation: {
      title: 'ใบเสนอราคา',
      createQuotation: 'สร้างใบเสนอราคา',
      vendor: 'ผู้ขาย',
      totalAmount: 'จำนวนเงินรวม',
      validUntil: 'ใช้ได้ถึง',
      approve: 'อนุมัติ',
      reject: 'ปฏิเสธ',
      approved: 'อนุมัติแล้ว',
      rejected: 'ปฏิเสธแล้ว',
      pending: 'รอดำเนินการ',
    },
    mealPlan: {
      title: 'แผนมื้ออาหาร',
      createMealPlan: 'สร้างแผนมื้ออาหาร',
      date: 'วันที่',
      mealType: 'ประเภทมื้ออาหาร',
      breakfast: 'อาหารเช้า',
      lunch: 'อาหารกลางวัน',
      dinner: 'อาหารเย็น',
      snack: 'ขนม',
      approve: 'อนุมัติ',
      reject: 'ปฏิเสธ',
      aiRecommend: 'คำแนะนำ AI',
    },
    notification: {
      title: 'การแจ้งเตือน',
      markAsRead: 'ทำเครื่องหมายว่าอ่านแล้ว',
      markAllRead: 'ทำเครื่องหมายทั้งหมดว่าอ่านแล้ว',
      noNotifications: 'ไม่มีการแจ้งเตือน',
      taskReminder: 'การแจ้งเตือนงาน',
      expenseApproved: 'อนุมัติค่าใช้จ่ายแล้ว',
      quotationApproved: 'อนุมัติใบเสนอราคาแล้ว',
    },
    settings: {
      title: 'การตั้งค่า',
      language: 'ภาษา',
      theme: 'ธีม',
      notifications: 'การแจ้งเตือน',
      account: 'บัญชี',
      privacy: 'ความเป็นส่วนตัว',
      about: 'เกี่ยวกับ',
      version: 'เวอร์ชัน',
      logout: 'ออกจากระบบ',
    },
    role: {
      employer: 'นายจ้าง',
      maid: 'แม่บ้าน',
      familyMember: 'สมาชิกครอบครัว',
      admin: 'ผู้ดูแลระบบ',
    },
    backup: {
      title: 'สำรองและกู้คืนข้อมูล',
      createBackup: 'สร้างข้อมูลสำรอง',
      restoreBackup: 'กู้คืนข้อมูลสำรอง',
      lastBackup: 'ข้อมูลสำรองล่าสุด',
      backupSuccess: 'สำรองข้อมูลสำเร็จ',
      restoreSuccess: 'กู้คืนข้อมูลสำเร็จ',
    },
    export: {
      title: 'ส่งออก',
      exportCSV: 'ส่งออกเป็น CSV',
      exportPDF: 'ส่งออกเป็น PDF',
      exportJSON: 'ส่งออกเป็น JSON',
      exportSuccess: 'ส่งออกสำเร็จ',
    },
  },
}
